module.exports = __webpack_public_path__ + "img/SKMJ_ladder1.7cf9e053.png";